export default {
  title: 'Merchant Payment reports',
  tableHeaderActionTooltip: 'Create new Merchant Payment report',
  dialog: {
    title: {
      generateReport: 'Generate Merchant Payment report',
      deleteReport: 'Delete Merchant Payment report',
      cancelReport: 'Cancel Merchant Payment report',
      regenerateReport: 'Regenerate Merchant Payment report',
      retryReport: 'Retry Merchant Payment report generation'
    }
  },
  tooltip: {
    generateReport: 'Generate Merchant Payment report',
    cancel: 'Cancel',
    delete: 'Delete',
    details: 'Details',
    download: 'Download',
    regenerate: 'Regenerate',
    retry: 'Retry'
  },
  reportName: {
    label: 'Report name',
    placeholder: 'Enter Merchant Payment report name'
  },
  filtersForm: {
    startingDate: {
      label: 'Starting date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    },
    endDate: {
      label: 'End date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    },
    statuses: {
      label: 'Status(es)',
      placeholder: 'Select status(es)'
    },
    operationId: {
      label: 'Operation Id(s)',
      placeholder: 'Enter operation Id(s)'
    },
    merchantCode: {
      label: 'Merchant Code(s)',
      placeholder: 'Enter merchant Code(s)'
    },
    customerMsisdn: {
      label: 'Customer phone number(s)',
      placeholder: 'Enter customer phone number(s)'
    }
  },
  details: {
    startingDate: {
      label: 'Starting date'
    },
    endDate: {
      label: 'End date'
    },
    statuses: {
      label: 'Status(es)'
    },
    operationIds: {
      label: 'Operation Id(s)'
    },
    customerMsisdn: {
      label: 'Customer phone number(s)'
    },
    merchantCode: {
      label: 'Merchant Code(s)'
    }
  },
  warningMsg:
    // eslint-disable-next-line max-len
    'You reached the max number of active/pending reports. To add a new one, or retry existing you need to delete the existing/pending ones.'
};
